import React from 'react';
import { Form } from 'react-final-form';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

import validate from '../../../../../../utils/validate';
import { replyYopValidation } from '../../../../../../scout-new/components/generation-section/components/repliesForm/replyValidation';
import RepliesFormInner from './RepliesFormInner';
import { useProject } from '../../../../../../context/ProjectContext';

function RepliesForm() {
  const { id } = useParams();
  const { actions } = useProject();

  const generationForm = useSelector((state) => state.activ8Messages.generationForm);

  const repliesFormInitialValues = {
    hint: generationForm.hint || '',
    reply: '',
  };

  const handleSubmit = async (values) => {
    await actions('replyMessages', { projectId: id, reply: values.reply });
  };

  return (
    <Form
      initialValues={repliesFormInitialValues}
      onSubmit={handleSubmit}
      subscription={{ submitting: true, pristine: true }}
      validateOnBlur={false}
      validate={(values) => validate(values, replyYopValidation())}
      render={({ handleSubmit }) => <RepliesFormInner onSubmit={handleSubmit} />}
    />
  );
}

export default RepliesForm;
